import React, { useEffect, useState } from 'react';
import ButtonSecondary from '../Button/ButtonSecondary';
import Button from '../Button/Button';
import './_styles.products-modal.scss';
import { validateStock } from '../../api';
import InputField from '../InputField/InputField';

const getProductKey = (product) =>
  `${product.Product_ID}_${product.Lot_ID}`;

const ProductsModal = ({ visible, partyId, siteId, onClose, onAdd }) => {
  const [results, setResults] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [quantities, setQuantities] = useState({});

  const Cancel = () => {
    onClose();
  };

  useEffect(() => {
    setResults([]);
    setFilteredResults([]);
    setSelectedProducts([]);
    setQuantities({});
    setSearchValue('');
    if (!visible) return;
    validateStock(partyId, siteId).then(({ data }) => {
      setResults(data.data);
      const initialQuantities = {};
      data.data.forEach((product) => {
        initialQuantities[getProductKey(product)] = product.Quantity;
      });
      setQuantities(initialQuantities);
    });
  }, [visible, partyId, siteId]);

  useEffect(() => {
    if (searchValue) {
      const filtered = results.filter(
        (product) =>
          product.Product.toLowerCase().includes(searchValue.toLowerCase()) ||
          product.Lot.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredResults(filtered);
    } else {
      setFilteredResults(results);
    }
  }, [searchValue, results]);

  return (
    <div
      className='detail-modal'
      style={{ display: visible ? 'block' : 'none' }}
    >
      <div
        className='detail-modal-content'
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className='modal-header'>
          <h3>Products</h3>
          <InputField
            placeholder='Search'
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
          />
        </div>
        <div>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Product</th>
                <th>Lot</th>
                <th>Exp. Date</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              {filteredResults &&
                filteredResults.map((product) => {
                  return (
                    <tr
                      key={product.Product + product.Lot + product.Quantity}
                      onClick={() => {
                        if (selectedProducts.includes(product)) {
                          setSelectedProducts(
                            selectedProducts.filter((p) => p !== product)
                          );
                        } else {
                          setSelectedProducts([...selectedProducts, product]);
                        }
                      }}
                    >
                      <td>
                        <input
                          type='checkbox'
                          checked={selectedProducts.includes(product)}
                        />
                      </td>
                      <td>{product.Product}</td>
                      <td>{product.Lot}</td>
                      <td>{product['Expiry Date']}</td>
                      <td onClick={(e) => e.stopPropagation()}>
                        <input
                          type='number'
                          min='1'
                          max={product.Quantity}
                          value={
                            quantities[getProductKey(product)] ??
                            product.Quantity
                          }
                          onChange={(e) =>
                            setQuantities({
                              ...quantities,
                              [getProductKey(product)]: e.target.value
                            })
                          }
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <div className='modal-footer'>
          <ButtonSecondary title='Cancel' onClick={Cancel} />
          <Button
            title={'Add'}
            onClick={() => {
              const productsWithQuantities = selectedProducts.map(
                (product) => ({
                  ...product,
                  Quantity:
                    quantities[getProductKey(product)] ?? product.Quantity
                })
              );
              onAdd(productsWithQuantities);
              Cancel();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductsModal;
